function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".arrowDown_svg__cls-1{fill:none;stroke:#000;stroke-width:2px}"));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "arrowDown_svg__Group_42",
  "data-name": "Group 42",
  transform: "rotate(90 5.5 6.207)"
}, React.createElement("path", {
  id: "arrowDown_svg__Line_1",
  d: "M0 0l6 6",
  className: "arrowDown_svg__cls-1",
  "data-name": "Line 1"
}), React.createElement("path", {
  id: "arrowDown_svg__Line_3",
  d: "M0 6l6-6",
  className: "arrowDown_svg__cls-1",
  "data-name": "Line 3",
  transform: "translate(0 5)"
}));

var SvgArrowDown = function SvgArrowDown(props) {
  return React.createElement("svg", _extends({
    width: 12.414,
    height: 7.414
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMi40MTQiIGhlaWdodD0iNy40MTQiIHZpZXdCb3g9IjAgMCAxMi40MTQgNy40MTQiPgogICAgPGRlZnM+CiAgICAgICAgPHN0eWxlPgogICAgICAgICAgICAuY2xzLTF7ZmlsbDpub25lO3N0cm9rZTojMDAwO3N0cm9rZS13aWR0aDoycHh9CiAgICAgICAgPC9zdHlsZT4KICAgIDwvZGVmcz4KICAgIDxnIGlkPSJHcm91cF80MiIgZGF0YS1uYW1lPSJHcm91cCA0MiIgdHJhbnNmb3JtPSJyb3RhdGUoOTAgNS41IDYuMjA3KSI+CiAgICAgICAgPHBhdGggaWQ9IkxpbmVfMSIgZD0iTTAgMGw2IDYiIGNsYXNzPSJjbHMtMSIgZGF0YS1uYW1lPSJMaW5lIDEiLz4KICAgICAgICA8cGF0aCBpZD0iTGluZV8zIiBkPSJNMCA2bDYtNiIgY2xhc3M9ImNscy0xIiBkYXRhLW5hbWU9IkxpbmUgMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCA1KSIvPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgArrowDown as ReactComponent };


//////////////////
// WEBPACK FOOTER
// /src/assets/img/arrowDown.svg
// module id = 2162
// module chunks = 0